import React from "react";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function ConsultationTabsNav({ tabs, onChange }) {
    const currentIndex = tabs.findIndex((tab) => tab.current);
    const safeCurrentIndex = currentIndex >= 0 ? currentIndex : 0;
    const currentTab = tabs[safeCurrentIndex];

    return (
        <section className="rounded-3xl border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-800 dark:bg-slate-950">
            <div className="md:hidden">
                <div className="rounded-2xl bg-slate-50 p-3 dark:bg-slate-900">
                    <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500 dark:text-slate-400">
                                Seccion {safeCurrentIndex + 1} de {tabs.length}
                            </p>
                            <p className="mt-1 text-sm font-semibold text-slate-900 dark:text-white">
                                {currentTab?.name}
                            </p>
                        </div>
                        <span className="rounded-full bg-white px-2.5 py-1 text-xs font-medium text-slate-600 ring-1 ring-slate-200 dark:bg-slate-950 dark:text-slate-300 dark:ring-slate-700">
                            Actual
                        </span>
                    </div>
                </div>
            </div>

            <nav
                className="mt-3 flex gap-2 overflow-x-auto pb-1 md:mt-0"
                aria-label="Tabs"
            >
                {tabs.map((tab) => (
                    <button
                        type="button"
                        key={tab.name}
                        onClick={() => onChange(tab.name)}
                        aria-current={tab.current ? "page" : undefined}
                        className={classNames(
                            "whitespace-nowrap rounded-2xl px-4 py-2 text-sm font-semibold transition md:px-4",
                            tab.current
                                ? "bg-primary text-white shadow-sm"
                                : "bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white"
                        )}
                    >
                        {tab.name}
                    </button>
                ))}
            </nav>
        </section>
    );
}
